import React, { useState, useContext } from 'react'
import get from 'lodash/get'
import qs from 'query-string'
import { useQuery } from '@apollo/react-hooks'

import NoData from 'components/NoData'
import Page404 from 'components/Page404'
import Loader from 'components/loaders/Loader'
import InterestTable from 'modules/Reports/Interest/InterestTable'
import {
  GET_INTEREST_REPORT,
  GET_USER_SAVING_OF_INTEREST_PDF,
} from 'modules/Reports/graphql/Queries'
import 'modules/Reports/index.css'
import { GET_USER } from 'modules/Users/graphql/Queries'
import CustomMeta from 'components/CustomMeta'
import { Button, Popover } from 'antd'
import client from 'apollo'
import PdfIcon from 'assets/images/new-images/pdficon.svg'
import { CSVLink } from 'react-csv'
import ExcelIcon from 'assets/images/new-images/excelIcon.svg'
import { DownloadOutlined } from '@ant-design/icons'
import { AppContext } from 'AppContext'
import { canUserDownload, canUserExport } from 'utils/User'

export default function (props) {
  let {
    match: {
      params: { clientCode, clientId },
    },
    history: {
      location: { search },
    },
  } = props
  const {
    state: { currentUser, isClient, userPermissions },
  } = useContext(AppContext)
  const hasExport = canUserExport(userPermissions || currentUser, isClient)
  const hasDownload = canUserDownload(userPermissions || currentUser, isClient)
  const [pdfLoading, setPdfLoading] = useState(false)

  const parsed = qs.parse(search || {})
  const { strategy = 'ILTS' } = parsed
  const { data, loading, error } = useQuery(GET_INTEREST_REPORT, {
    variables: { where: { clientCode, date: null, strategy } },
  })
  const {
    data: getUserData,
    loading: getUserLoading,
    error: getUserError,
  } = useQuery(GET_USER, { variables: { id: clientId } })

  if (loading || getUserLoading) return <Loader />
  if (error || getUserError) return <Page404 error={error} />
  if (!get(data, 'spInterestReport')) return <NoData />

  const {
    spInterestReport: [spInterestReport],
  } = data

  const generatePDF = async () => {
    try {
      setPdfLoading(true)
      await client
        .query({
          query: GET_USER_SAVING_OF_INTEREST_PDF,
          variables: {
            data: {
              fileName: `SAVING-OF-INTEREST-REPORT-${clientCode}`,
              clientCode: clientCode,
              strategy: '1005',
            },
          },
          fetchPolicy: 'network-only',
        })
        .then((res) => {
          if (res?.data?.getUserPerformancePDFs) {
            window.open(res.data.getUserPerformancePDFs, '_blank')
          }
        })
    } catch (error) {
      console.error('Error generating PDF:', error)
    } finally {
      setPdfLoading(false)
    }
  }

  const content = (
    <div>
      {hasDownload && (
        <Button
          onClick={generatePDF}
          loading={pdfLoading}
          style={{
            padding: '0px',
            marginBottom: '0px',
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '24px',
            textAlign: 'left',
            color: ' #000',
            cursor: 'pointer',
            border: 'none',
          }}
        >
          <img src={PdfIcon} style={{ marginRight: '10px' }} alt='pdf' /> PDF
        </Button>
      )}
      {hasDownload && hasExport && <br />}
      {hasExport && (
        <CSVLink
          data={spInterestReport}
          filename={`SAVING-OF-INTEREST-REPORT-${clientCode}.csv`}
          className='csv-btn'
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            style={{
              padding: '0px',
              marginBottom: '0px',
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '24px',
              textAlign: 'left',
              color: '#000',
              cursor: 'pointer',
              border: 'none',
            }}
          >
            <img src={ExcelIcon} style={{ marginRight: '10px' }} alt='excel' />{' '}
            CSV
          </Button>
        </CSVLink>
      )}
    </div>
  )
  return (
    <>
      <CustomMeta title='Saving Of Interest' />
      <div className='report_Container'>
        <div className='container_Header'>
          <div className='report_Heading'>Saving Interest Report</div>
          {(hasExport || hasDownload) && (
            <div className='download_report_container'>
              <Popover content={content} placement='bottom' trigger='click'>
                <div className='container_Export_Popover'>
                  <Button>
                    Export{' '}
                    <DownloadOutlined
                      color='#AF0000'
                      style={{ fontSize: '16px' }}
                    />
                  </Button>
                </div>
              </Popover>
            </div>
          )}{' '}
        </div>
        <div className='report_first_Container'>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className='Client_Info_Container'>
              <div className='client_Info'>
                Client Code:&nbsp;
                <span>{clientCode}</span>
              </div>

              <div className='client_Info'>
                Client Name:&nbsp;
                <span>
                  {getUserData?.getUser?.firstName}{' '}
                  {getUserData?.getUser?.lastName}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className='report-table-wrapper' id='INTEREST-REPORT-PDF'>
          <InterestTable
            reportData={spInterestReport}
            ClientCode={clientCode}
            user={getUserData}
          />
        </div>
      </div>
    </>
  )
}
